import React from 'react';
import { useStore } from 'hooks';
import { ROLE } from 'helpers/constants';
import AuthRoutes from './auth';
import UserRoutes from './user';
import AdminRoutes from './admin';
import ManagerRoutes from './manager';

const Routes = () => {
  const { user } = useStore();

  return user ? (
    <>
      {ROLE.isRole(user.role.code, [ROLE.USER]) && <UserRoutes />}
      {ROLE.isRole(user.role.code, [ROLE.ADMIN]) && <AdminRoutes />}
      {ROLE.isRole(user.role.code, [ROLE.MANAGER]) && <ManagerRoutes />}
    </>
  ) : <AuthRoutes />;
};

export default Routes;
